export default defineNuxtRouteMiddleware((to) => {
  const appConfig = useAppConfig()
  if (appConfig.netzo?.auth?.allowUserRegistration !== true) return navigateTo('/auth/login')
})
